export const mapSentimentToIcon = {
  Unknown: 'remove_circle_outline',
  POSITIVE: 'sentiment_very_satisfied',
  NEUTRAL: 'sentiment_satisfied',
  MIXED: 'sentiment_dissatisfied',
  NEGATIVE: 'sentiment_very_dissatisfied'
};
